var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7594 0.472122C16.9937 0.718252 17.1254 1.05203 17.1254 1.40006C17.1254 1.74809 16.9937 2.08187 16.7594 2.328L7.39022 12.1656C7.2664 12.2957 7.1194 12.3988 6.95762 12.4692C6.79583 12.5396 6.62242 12.5758 6.4473 12.5758C6.27218 12.5758 6.09877 12.5396 5.93699 12.4692C5.7752 12.3988 5.6282 12.2957 5.50438 12.1656L0.849384 7.27875C0.729996 7.15767 0.634768 7.01285 0.569257 6.85272C0.503746 6.69258 0.469263 6.52036 0.467821 6.34609C0.466378 6.17181 0.498006 5.99898 0.560857 5.83768C0.623708 5.67638 0.716524 5.52984 0.83389 5.4066C0.951256 5.28337 1.09082 5.18591 1.24444 5.11992C1.39806 5.05393 1.56266 5.02072 1.72864 5.02223C1.89461 5.02374 2.05863 5.05995 2.21114 5.12874C2.36364 5.19753 2.50158 5.29751 2.61688 5.42287L6.44688 9.44437L14.9911 0.472122C15.1071 0.350156 15.245 0.253403 15.3967 0.187391C15.5484 0.121379 15.711 0.0874023 15.8752 0.0874023C16.0394 0.0874023 16.202 0.121379 16.3538 0.187391C16.5055 0.253403 16.6433 0.350156 16.7594 0.472122Z",
    fill: "#7544B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.b78a9ba372460c36cc1e430b7ec4e62a.svg";
export { ForwardRef as ReactComponent };